import React from 'react';
import { Route, Switch } from 'wouter';
import Navbar from './components/Navbar';
import CustomCursor from './components/CustomCursor';
import Experience from './components/FerrisWheel/Experience';
import Team from './pages/Team';
import Memories from './pages/Memories';
import LoaderUI from './components/LoaderUI';
import Contact from './pages/Contact';
import Performers from './pages/Performers'; // Added Performers route

function App() {
    return (
        <>
            <LoaderUI />
            <CustomCursor />
            <Navbar />

            <Switch>
                <Route path="/">
                    <Experience />
                </Route>
                <Route path="/team" component={Team} />
                <Route path="/memories" component={Memories} />
                <Route path="/performers" component={Performers} /> {/* Added Performers route */}
                <Route path="/contact" component={Contact} /> {/* Added Contact route */}
                <Route>
                    {/* 404 - Redirect to home */}
                    {() => { window.location.href = '/'; return null; }}
                </Route>
            </Switch>
        </>
    )
}

export default App
